import { APP_ROUTES } from "./app-rotas.constants";

// ----------------------------------------------- RESOLUCAO DE TAG POR URL --------------------------------------
type RotaComTag = { url: string; tag: string };

/** Percorre `APP_ROUTES` coletando as folhas que possuem `url` e `tag`. */
function coletarRotasComTag(no: unknown, acc: RotaComTag[]): void {
	if (!no || typeof no !== "object") return;

	const registro = no as Record<string, unknown>;
	const { url, tag } = registro;

	if (typeof url === "string" && typeof tag === "string") {
		acc.push({ url, tag });
		return;
	}

	Object.values(registro).forEach((valor) => coletarRotasComTag(valor, acc));
}

const ROTAS_COM_TAG: RotaComTag[] = (() => {
	const acc: RotaComTag[] = [];
	coletarRotasComTag(APP_ROUTES, acc);
	return acc;
})();

function normalizarPathname(pathname: string): string {
	if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
	return pathname;
}

/**
 * Resolve a `tag` da rota correspondente a um pathname (ex.: a tela atual, para o modal no header).
 * Faz match exato pela `url` definida em `APP_ROUTES`; retorna null quando a rota nao possui tag.
 */
export function obterTagPorUrl(pathname: string): string | null {
	const alvo = normalizarPathname(pathname);
	return ROTAS_COM_TAG.find((rota) => normalizarPathname(rota.url) === alvo)?.tag ?? null;
}
